import React from "react";
import { cn, useSidebar } from "@adora/shadcn-ui";

export const CommandBarWrapper = ({
  children,
  commonPageHeaderSpacing = false,
  radioPlusOverflowStyle = false,
  additionalContent = null,
  style = {}
}: {
  children: React.ReactNode;
  commonPageHeaderSpacing?: boolean;
  radioPlusOverflowStyle?: boolean;
  additionalContent?: React.ReactNode;
  style?: React.CSSProperties;
}) => {
  const { open } = useSidebar();

  return (
    <div
      className={cn(
        "flex flex-col items-center justify-center gap-3 shrink-0 py-2 sticky z-10 bg-background print:static print:!shadow-none",
        commonPageHeaderSpacing && "mb-[72px]",
        open ? "" : "overflow-x-auto whitespace-nowrap"
      )}
      style={{
        top: "var(--page-sticky-offset, 68px)",
        boxShadow: "0 -1px 0 2px white",
        ...style
      }}
    >
      {radioPlusOverflowStyle && <div className="p-2 w-6 h-6 invisible mr-2"></div>}
      <div className={cn("flex gap-2 items-center", open ? "flex-wrap" : "flex-nowrap")}>{children}</div>
      {additionalContent}
    </div>
  );
};
